import { useEffect, useState } from 'react'
import styles from './BookingPage.module.css'
import SearchPanel from '../../components/SearchPanel/SearchPanel'
import BookingForm from '../../components/BookingForm/BookingForm'
import { useAppDispatch, useAppSelector } from '../../redux/types/types'
import PublicPlaceItem from '../../components/PublicPlaceItem/PublicPlaceItem'
import PublicMenu from '../../components/PublicMenu/PublicMenu'
import { setActiveTab, setSelectedPlace, nextTab } from '../../redux/reducers/bookingTabs'
import PublicEndOrder from '../../components/PublicEndOrder/PublicEndOrder'
import PublicBookingSuccess from '../../components/PublicBookingSuccess/PublicBookingSuccess'

const BookingPage = () => {
  const dispatch = useAppDispatch()
  const { activeTab, completedTabs } = useAppSelector((state) => state.bookingTabs)
  const places = useAppSelector((state) => state.places.places.places)
  const [hasSearched, setHasSearched] = useState(false)

  useEffect(() => {
    if (places.length > 0) {
      setHasSearched(true)
    }
  }, [places])

  const handleTabClick = (tabIndex: number) => {
    const isCurrentTab = tabIndex === activeTab
    const isCompletedTab = isTabCompleted(tabIndex)
    const isNextAvailableTab = tabIndex === Math.max(...completedTabs, -1) + 1

    if (isCurrentTab || isCompletedTab || isNextAvailableTab) {
      dispatch(setActiveTab(tabIndex))
    }
  }

  const handleNextTab = () => {
    dispatch(nextTab())
  }

  const isTabCompleted = (tabIndex: number) => {
    return completedTabs.includes(tabIndex)
  }

  const isTabAccessible = (tabIndex: number) => {
    const isCurrentTab = tabIndex === activeTab
    const isCompletedTab = isTabCompleted(tabIndex)
    const isNextAvailableTab = tabIndex === Math.max(...completedTabs, -1) + 1

    return isCurrentTab || isCompletedTab || isNextAvailableTab
  }

  const handleSearchPerformed = () => {
    setHasSearched(true)
  }

  return (
    <div className={styles.bookingPage}>
      <div className={styles.bookingPageHeader}>
        <h1>Бронирование конференц-залов</h1>
      </div>
      <div className={styles.bookingPageTabs}>
        <div
          className={`${styles.bookingPageTabsItem} ${activeTab === 0 ? styles.active : ''} ${
            isTabCompleted(0) ? styles.completed : ''
          } ${!isTabAccessible(0) ? styles.disabled : ''}`}
          onClick={() => handleTabClick(0)}
        >
          <div className={styles.bookingPageTabsItemNumber}>1</div>
          <div className={styles.bookingPageTabsItemText}>Залы</div>
        </div>
        <div
          className={`${styles.bookingPageTabsItem} ${activeTab === 1 ? styles.active : ''} ${
            isTabCompleted(1) ? styles.completed : ''
          } ${!isTabAccessible(1) ? styles.disabled : ''}`}
          onClick={() => handleTabClick(1)}
        >
          <div className={styles.bookingPageTabsItemNumber}>2</div>
          <div className={styles.bookingPageTabsItemText}>Дополнительные услуги</div>
        </div>
        <div
          className={`${styles.bookingPageTabsItem} ${activeTab === 2 ? styles.active : ''} ${
            isTabCompleted(2) ? styles.completed : ''
          } ${!isTabAccessible(2) ? styles.disabled : ''}`}
          onClick={() => handleTabClick(2)}
        >
          <div className={styles.bookingPageTabsItemNumber}>3</div>
          <div className={styles.bookingPageTabsItemText}>Оплата</div>
        </div>
        <div
          className={`${styles.bookingPageTabsItem} ${activeTab === 3 ? styles.active : ''} ${
            isTabCompleted(3) ? styles.completed : ''
          } ${!isTabAccessible(3) ? styles.disabled : ''}`}
          onClick={() => handleTabClick(3)}
        >
          <div className={styles.bookingPageTabsItemNumber}>4</div>
          <div className={styles.bookingPageTabsItemText}>Подтверждение</div>
        </div>
      </div>

      {activeTab === 0 && (
        <>
          <div className={styles.filterContainer}>
            <SearchPanel
              isBookingPage={true}
              currentPage={1}
              onSearchPerformed={handleSearchPerformed}
            />
          </div>
          <div className={styles.publicPlaceItems}>
            {!hasSearched ? (
              <div className={styles.emptyMessage}>
                Пожалуйста, выберите даты начала и окончания, а также количество гостей для поиска
                доступных залов
              </div>
            ) : places.length === 0 ? (
              <div className={styles.emptyMessage}>По запросу ничего не найдено</div>
            ) : (
              places.map((place) => (
                <PublicPlaceItem
                  setSelectedPlace={(place) => dispatch(setSelectedPlace(place))}
                  key={place.id}
                  place={place}
                />
              ))
            )}
          </div>
        </>
      )}

      {activeTab === 1 && <PublicMenu handleNextTab={handleNextTab} />}

      {activeTab === 2 && (
        <div className={styles.tabContent}>
          <BookingForm handleNextTab={handleNextTab} />
          <PublicEndOrder />
        </div>
      )}

      {activeTab === 3 && <PublicBookingSuccess />}
    </div>
  )
}

export default BookingPage
